import type { UserProfile } from '@/models/login.model';
import { resetAllStores } from '../stores';
import { CrudService } from './crud.service';

export class LoginService {
  private readonly crudService = new CrudService();

  public async login(username: string, password: string, accountId: string): Promise<UserProfile> {
    return await this.sendLoginRequest(username, password, accountId);
  }

  public async logout() {
    try {
      return await Promise.all([this.crudService.do('POST', 'logout'), resetAllStores()]);
    } catch {
      /* empty */
    }
  }

  private async sendLoginRequest(username: string, password: string, accountId: string): Promise<UserProfile> {
    const queryParams = new URLSearchParams();
    queryParams.set('accountId', accountId);
    try {
      const { model } = await this.crudService.do(
        'POST',
        `login?${queryParams}`,
        { username, password },
        undefined,
        'throw',
      );
      return model;
    } catch (e: any) {
      throw new Error(e.response.data.messageCode);
    }
  }
}
